// @ts-nocheck
interface Api {
  url: string
  endpoints: {
    [action: string]: (calculationId?: string) => string
  }
}

const { REACT_APP_CALCULATION_SUITE_API_URL = '' } = process.env

/**
 * This app is a public caller, so it says so.
 *
 * In a deployed environment the nginx ingress stamps this header on everything
 * it proxies and `proxy_set_header` replaces whatever the client sent, so this
 * value is overwritten in transit and nothing here can weaken the boundary.
 * Sending it matters for a local run, where there is no ingress: without it the
 * API would serve this app the full internal view, and the licensed-instrument
 * behaviour could not be exercised outside a cluster.
 */
export const PUBLIC_BOUNDARY_HEADERS = Object.freeze({
  'X-Awell-Public': '1'
})

export const api: Readonly<Api> = Object.freeze({
  url: REACT_APP_CALCULATION_SUITE_API_URL,
  endpoints: {
    GET_SINGLE_CALCULATION: (calculationId) => `/calculations/${calculationId}`, // GET
    GET_ALL_CALCULATIONS: () => '/calculations', // GET
    EXECUTE_CALCULATION: () => '/calculations', // POST
    SIMULATE_CALCULATION: (calculationId) =>
      `/calculations/simulate/${calculationId}`, // GET
    UPLOAD_CSV_FOR_CALCULATION: (calculationId) =>
      `/calculations/${calculationId}/csv`, // POST
    DOWNLOAD_CSV_FILE: (fileName) =>
      `/downloads/csv_with_calculation_results/${fileName}` // GET
  }
})
